function norm(s: string): string {
  return String(s || "")
    .toLowerCase()
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .trim();
}

export function suggestServiceIdFromNotes(
  notes: string | null | undefined,
  services: Array<{ id: string; name: string }>,
  defaultServiceId: string
): string {
  const n = norm(notes || "");
  if (!n) return defaultServiceId;

  const scored = services.map((s) => {
    const name = norm(s.name);
    let score = 0;

    // Strong keywords
    if (/\bfondo\b/.test(n) && /\bfondo\b/.test(name)) score += 50;
    if (/\bcambio\b/.test(n) && /\bcambio\b/.test(name)) score += 40;

    // Apartment size hints
    if (/\bmono(locale)?\b/.test(n) && /\bmono(locale)?\b/.test(name)) score += 30;
    if (/\bbi(locale)?\b/.test(n) && /\bbi(locale)?\b/.test(name)) score += 30;
    if (/\btri(locale)?\b/.test(n) && /\btri(locale)?\b/.test(name)) score += 30;

    // If notes contains a fragment of service name
    if (n.length >= 6 && name.length >= 6 && n.includes(name)) score += 25;
    if (name.length >= 6 && n.includes(name.slice(0, 8))) score += 10;

    return { id: s.id, score };
  });

  scored.sort((a, b) => b.score - a.score);
  if (scored[0] && scored[0].score >= 30) return scored[0].id;
  return defaultServiceId;
}

